"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyUserGridSettings = void 0;
exports.getAll = getAll;
exports.getFilters = void 0;
exports.getGridDetailsForApp = getGridDetailsForApp;
exports.getGridSettings = getGridSettings;
exports.getOne = getOne;
exports.getUserGridColumns = getUserGridColumns;
exports.saveFilter = exports.resetUserGridColumns = void 0;
exports.sortColumns = sortColumns;
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _client = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/gridKeyAppolloClient/client"));
var _utils = require("cornerstone_ui_core/lib/utils");
var _lodash = require("lodash");
var _gridSettings = require("./grid-settings.helper");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function getGridDetailsForApp() {
  let appId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage.getItem("AppId");
  return _client.default.query({
    query: (0, _graphqlTag.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["{\n        grids : getGridDetailsForApp(appId: ", ") {\n          gridId\n          gridKey\n          gridTitle\n        }\n      }"])), appId),
    fetchPolicy: "no-cache"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref => {
    let {
      data
    } = _ref;
    return data;
  }).catch(_utils.errorHandler);
}
function sortColumns() {
  let columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (columns) return columns.sort((a, b) => a.columnOrder - b.columnOrder);
  return [];
}
function getUserGridColumns(gridKey) {
  return _client.default.query({
    query: (0, _graphqlTag.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{\n          columns : getUserGridColumns(gridKey: \"", "\") {\n            columnHeader\n            columnAttribute\n            columnOrder\n            filterName\n            filterValue\n            columnSortAttribute\n            columnWidth\n            filterFlag\n            filterIndicator\n            sortIndicator\n            visibleIndicator\n            gridColumnId\n            columnName\n            userGrid {\n              gridId\n              gridKey\n              gridTitle\n            }\n          }\n        }"])), gridKey),
    fetchPolicy: "no-cache"
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref2 => {
    let {
      data
    } = _ref2;
    return data;
  }).then(_ref3 => {
    let {
      columns
    } = _ref3;
    if (columns) return {
      columns: sortColumns(columns).filter(col => col.columnAttribute)
    };
    throw new Error("Columns not loaded.");
  }).catch(_utils.errorHandler);
}
function getOne(gridKey) {
  return getUserGridColumns(gridKey).then(_ref4 => {
    let {
      columns
    } = _ref4;
    return {
      [(0, _gridSettings.getGridConstantName)(gridKey)]: columns
    };
  });
}
function getAll() {
  let gridKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Promise.all(gridKeys.map(getGridSettings)).then(arr => {
    return arr.reduce((acc, obj) => {
      return {
        ...acc,
        ...obj
      };
    }, {});
  });
}
function getGridSettings(gridKey) {
  if (Array.isArray(gridKey)) {
    return getAll(gridKey);
  }
  return getOne(gridKey);
}
const applyUserGridSettings = _ref5 => {
  let {
    gridKey,
    userGridColumnList
  } = _ref5;
  const UserGridColumnVOInput = userGridColumnList.map(_ref6 => {
    let {
      columnHeader,
      columnAttribute,
      columnOrder,
      columnSortAttribute,
      columnWidth,
      filterIndicator,
      sortIndicator,
      visibleIndicator,
      columnName,
      filterName,
      filterFlag,
      filterValue
    } = _ref6;
    return {
      columnHeader,
      columnAttribute,
      columnOrder,
      columnSortAttribute,
      columnWidth,
      filterIndicator,
      sortIndicator,
      visibleIndicator,
      filterName,
      filterValue,
      filterFlag,
      columnName
    };
  });
  return _client.default.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        mutation applyUserGridSettings(\n          $gridKey: String\n          $userGridColumnList: [UserGridColumnVOInput]\n        ) {\n          applyUserGridSettings(\n            gridKey: $gridKey\n            userGridColumnList: $userGridColumnList\n          ) {\n            statusMessage\n            statusCode\n          }\n        }\n      "]))),
    variables: {
      gridKey,
      userGridColumnList: sortColumns(UserGridColumnVOInput)
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref7 => {
    let {
      data
    } = _ref7;
    return data.applyUserGridSettings;
  }).then(res => {
    return {
      [(0, _gridSettings.getGridConstantName)(gridKey)]: userGridColumnList
    };
  }).catch(_utils.errorHandler);
};
exports.applyUserGridSettings = applyUserGridSettings;
const resetUserGridColumns = _ref8 => {
  let {
    gridKey
  } = _ref8;
  return _client.default.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        mutation resetUserGridColumns($gridKey: String) {\n          resetUserGridColumns(gridKey: $gridKey) {\n            statusMessage\n            statusCode\n          }\n        }\n      "]))),
    variables: {
      gridKey
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref9 => {
    let {
      data
    } = _ref9;
    return data.resetUserGridColumns;
  }).then(res => {
    return getGridSettings(gridKey);
  }).catch(_utils.errorHandler);
};
exports.resetUserGridColumns = resetUserGridColumns;
const saveFilter = input => {
  return _client.default.mutate({
    mutation: (0, _graphqlTag.default)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        mutation($input: [FilterRequestVO]) {\n          saveFilter: createFilters(input: $input) {\n            id\n            statusMessage\n            statusCode\n          }\n        }\n      "]))),
    variables: {
      input
    }
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref10 => {
    let {
      data
    } = _ref10;
    return data;
  }).catch(_utils.errorHandler);
};
exports.saveFilter = saveFilter;
const getFilters = _ref11 => {
  let {
    attributeId,
    attributeType
  } = _ref11;
  const constantName = (0, _gridSettings.getFilterConstantName)({
    attributeId,
    attributeType
  });
  return _client.default.query({
    query: (0, _graphqlTag.default)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["{\n           getFilters(attributeId: ", ", attributeType: \"", "\"){\n            filterColumnId\n            attributeId\n            attributeType\n            filterFlag\n            filterValue\n            filterRequestAttributeVOs{\n              attributeName\n              attributeType\n              attributeCriteria\n              attributeValues\n            }\n            filterName\n          }\n      }"])), attributeId, attributeType)
  }).then(res => (0, _lodash.cloneDeep)(res)).then(_ref12 => {
    let {
      data
    } = _ref12;
    return data;
  }).then(_ref13 => {
    let {
      getFilters
    } = _ref13;
    return {
      [constantName]: getFilters
    };
  }).catch(_utils.errorHandler);
};
exports.getFilters = getFilters;